import styled from "styled-components";

export const Label = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  span {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    border-radius: 12px;
    font-size: 14px;
    padding: 4px 10px;
    color: #88451D;
    background-color: #FCF3CC;
  }
`